/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";
import parseHtmlContent from "helpers/parseHtmlContent";

import {WealthyEnv} from "helpers";

import {
  SectionTitle,
  container
} from "../common";
import {AccordianItem} from "./components";

const promoImage = `url(${WealthyEnv.BROKING_CDN_URL}/phone-blurred-bg.png)`;

const BrokingFaqs = ({
  faqList
}) => {
  return (
    <>
      <Section>
        <FaqContainer>
          <SectionTitle>
          FAQs
          </SectionTitle>
          <FaqList>
            {
              faqList.map((faq, index) => (
                <AccordianItem
                  content={parseHtmlContent(faq.answer)}
                  key={index}
                  title={faq.question}
                />
              ))
            }
          </FaqList>
        </FaqContainer>
      </Section>
    </>
  );
};

const Section = styled.section`
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: -100%;
    right: 0;
    background-image: ${promoImage};
    width: 268px;
    height: 744px;
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media (max-width: 1200px) {
    &::before {
      content: unset;
    }
  }
`;

const FaqContainer = styled(container)`
  margin: 0 auto 10rem;
  position: relative;

  @media (max-width: 576px) {
    margin: 0 auto 4rem;
  }
`;

const FaqList = styled.div`
  margin-top: 6rem;
  font-size: 2.2rem;

  @media (max-width: 576px) {
    margin-top: 1.6rem;
    font-size: 1.4rem;
  }
`;

export default BrokingFaqs;
